import { CommonModule } from '@angular/common';
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import {
  EMicaChat_DireccionMensaje,
  EMicaChat_EstadoMensaje,
  EMicaChat_TipoMensaje,
} from '@core/enums/micachat.enum';
import { MicaChat_MensajesEntity } from '@modules/mica-chat/entities/mensajes.mica-chat';
import { MicaChatMensajeMedia } from '../mica-chat-mensaje-media/mica-chat-mensaje-media';
import { micaChat_getColorRandom } from '@modules/mica-chat/utils/selector-random-color.mica-chat';

@Component({
  selector: 'app-chat-message-bubble',
  standalone: true,
  imports: [CommonModule, MicaChatMensajeMedia],
  templateUrl: './chat-message-bubble.html',
  styleUrl: './chat-message-bubble.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.self-start]': 'isInbound()',
    '[class.self-end]': 'isOutbound()',
  },
})
export class ChatMessageBubbleComponent {
  mensaje = input.required<MicaChat_MensajesEntity>();
  nameShort = input.required<string>();
  nombreContacto = input<string>('');

  readonly isInbound = computed(
    () => this.mensaje().direccion === EMicaChat_DireccionMensaje.INBOUND,
  );
  readonly isOutbound = computed(
    () => this.mensaje().direccion !== EMicaChat_DireccionMensaje.INBOUND,
  );

  readonly EMicaChat_DireccionMensaje = EMicaChat_DireccionMensaje;
  readonly EMicaChat_EstadoMensaje = EMicaChat_EstadoMensaje;
  readonly EMicaChat_TipoMensaje = EMicaChat_TipoMensaje;

  getColor() {
    return micaChat_getColorRandom(this.nombreContacto());
  }

  getReactionEmoji(): string | null {
    const payload = this.mensaje().payload;
    if (!payload) return null;
    const lastReaction = payload['last_reaction'];
    if (!lastReaction || typeof lastReaction !== 'object') return null;
    const emoji = (lastReaction as Record<string, unknown>)['emoji'];
    if (typeof emoji !== 'string') return null;
    return emoji.trim() || null;
  }
}
